import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { AbstractAdvisorComponent } from "../abstract/advisor.component";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { ValidationService } from "../../service/validation.service";
import { User } from "../../entity/User";
import { Company } from "../../entity/Company";
import { State } from "../../entity/State";
import { Pair } from "../../obj/Pair";
import { HeaderComponent } from "../incs/header.component";
import { NgxMaskDirective } from "ngx-mask";
import { OneClickDirective } from "../helpers/one-click.component";

@Component({
    selector: "kilowant-client-details",
    templateUrl: "../../../html/advisor/main-client-details.html",
    imports: [HeaderComponent, FormsModule, NgxMaskDirective, ReactiveFormsModule, OneClickDirective]
})
export class ClientDetailsComponent extends AbstractAdvisorComponent {
    states: State[] = [];
    currentPhoneNumber: FormControl = new FormControl("");
    clientInfo: User = new User();
    cities: string[] = [];
    confirmButtonActive: boolean = true;
    companyName: string | null = null;
    fileToUpload: File | null = null;
    taxExemptCertificateDocument: Pair | null = null;
    federalTaxID: string;
    deleteTaxExemptCertificateDocument: boolean;
    taxExempt: boolean;


    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        public validationService: ValidationService,
        dialog: MatDialog
    ) {
        super(router, route, dialog, authService, analyticsService, generalService);
    }

    ngOnInit(): void {
        this.generalService.getStates(false).then((states: any) => {
            this.states = states;
            if (this.clientInfo.state == null) {
                this.clientInfo.state = this.states[0];
                this.filterCities();
            }
        });
        this.filterCities();
    }

    confirm(): void {
        this.clearErrors();
        if (this.clientInfo.firstName == null || this.clientInfo.firstName.length == 0) {
            this.addError("FirstName");
        }
        if (this.clientInfo.lastName == null || this.clientInfo.lastName.length == 0) {
            this.addError("LastName");
        }
        if (this.clientInfo.email == null || this.clientInfo.email.length == 0) {
            this.addError("Email");
        }
        if (this.clientInfo.addressLine1 == null || this.clientInfo.addressLine1 == "") {
            this.addError("addressLine1");
        }
        if (this.clientInfo.state == null) {
            this.addError("stateId");
        }
        if (this.clientInfo.zip == null || this.clientInfo.zip == "") {
            this.addError("zip");
        }
        if (this.clientInfo.city == null || this.clientInfo.city == "") {
            this.addError("city");
        }

        if (this.currentPhoneNumber.value == null || this.currentPhoneNumber.value.length == 0) {
            this.addError("Phone");
        }

        if (this.companyName != null && this.taxExempt == true && (this.federalTaxID == null || this.federalTaxID.length == 0)) {
            this.addError("FederalTaxID");
        }
        if (this.companyName != null && this.taxExempt == true && this.fileToUpload == null && this.taxExemptCertificateDocument == null) {
            this.addError("fileToUpload");
        }

        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above.");
            this.confirmButtonActive = true;
            return;
        }

        if (!this.currentPhoneNumber.valid) {
            this.addError("Phone");
            this.setErrorText("Phone number is not correct.");
            this.confirmButtonActive = true;
            return;
        }
        this.clientInfo.phone = this.currentPhoneNumber.value;


        if (this.companyName != null && this.companyName.length > 0) {
            this.clientInfo.company = new Company();
            this.clientInfo.company.name = this.companyName;
            this.clientInfo.company.state = this.clientInfo.state!;
            this.clientInfo.company.city = this.clientInfo.city!;
            this.clientInfo.company.zip = this.clientInfo.zip!;
            this.clientInfo.company.addressLine1 = this.clientInfo.addressLine1!;
            this.clientInfo.company.addressLine2 = this.clientInfo.addressLine2!;
            this.clientInfo.company.phone = this.clientInfo.phone!;
            this.clientInfo.company.taxExempt = this.taxExempt;
            this.clientInfo.company.federalTaxID = this.federalTaxID;
        }


        this.generalService.registerUser(this.clientInfo, null, null, this.fileToUpload, true)
            .subscribe((res: any) => {
                if (res) {
                    this.clientInfo.id = res;
                    if (this.clientInfo.isActive) {
                        this.generalService.switchStoredClient(this.clientInfo);
                    }
                    this.goBack();
                }
            },
                err => {
                    if (parseInt(err.status) == 400) {
                        this.addError("Email");
                        this.setErrorText(err.error);
                        this.confirmButtonActive = true;
                    }
                });
    }

    filterCities(): void {
        this.cities = [];
        if (this.clientInfo.state == null) {
            return;
        }
        this.generalService.getCities(this.clientInfo.state).then((cities) => {
            this.cities = cities;
        });
    }

    downloadFile(ifExisting: boolean, id: number | null) {
        if (!ifExisting) {
            this.generalService.sendFileToClient(this.fileToUpload);
        } else if (id != null) {
            this.generalService.sendFileFromServerToClient(id);
        }
    }

    deleteFile() {
        this.fileToUpload = null;
    }

    handleFileInput(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileToUpload = (target.files as FileList).item(0) as File;
        this.resetError("fileToUpload");
    }

    deleteExistingFile(key: number) {
        this.deleteTaxExemptCertificateDocument = true;
        this.taxExemptCertificateDocument = null!;
    }


    goBack(): void {
        this.router.navigate(["/user/home"]);
    }

}
